var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton", {
        staticClass: "mt-2",
        attrs: { animation: "fade", width: "90%", height: "1.5rem" },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "mt-4",
        attrs: { animation: "fade", width: "90%", height: "2.5rem" },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "mt-2",
        attrs: { animation: "fade", width: "90%", height: "15rem" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }